// extracted by mini-css-extract-plugin
export default {"Hero":"Hero_Hero__PZgiZ","HeroTitle":"Hero_HeroTitle__Yxukz","HeroImage":"Hero_HeroImage__VPaIQ"};